import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";

const columns = [
  {
    accessor: "item",
    header: "Sales Order number",
    cell: (row) => <>{row?.item?.item_code}</>,
  },
  {
    accessor: "work_order_req_quantity",
    header: "Work Order Request Quantity",
  },
  {
    accessor: "bom_id",
    header: "BOM code",
    cell: (row) => <>{row?.bom?.bom_code}</>,
  },
  {
    accessor: "work_order",
    header: "Work Order Id",
    cell: (row) => <>{row?.work_order?.work_order_code}</>,
  },
  {
    accessor: "allotted_stock",
    header: "Alloted Stock",
    cell: (row) => <>{row?.allotted_stock}</>,
  }
];

const BO = () => {
  const privileges = secureLocalStorage.getItem("privileges");
  const navigate = useNavigate();
  const [boEntries, setBOEntries] = useState(5);
  const [boPageIndex, setBOPageIndex] = useState(0);
  const [search, setSearch] = useState("");

  const { useFetch } = useAPIQuery({
    key: "bo",
    endpoint: "/api/build-order/",
  });

  const { data, isLoading } = useFetch({
    params: {
      entries: boEntries,
      page_no: boPageIndex + 1,
      event: search ? search : undefined,
    },
    abortOnNewRequest: true,
    refetchOnWindowFocus: false,
    staleTime : 1000 * 60 * 3,
    retry : 3,
    keepPlaceholder : true,
    refetchOnReconnect : true
  });

  const { useDelete } = useAPIQuery({
    key: "bo",
    endpoint: "/api/build-order/",
  });

  const { mutate: deleteData } = useDelete();

  const handleGlobalFilterChange = (value) => {
    console.log(value);
    setSearch(value);
  };

  const handlePagination = (value) => {
    console.log(value);
    setBOPageIndex(value.pageIndex);
    setBOEntries(value.pageSize);
  };

  const handleEditRow = (row) => {
    console.log(row);
    navigate("/edit-bo", { state: { editpost: row.original } });
  };

  const handleDeleteRow = (row) => {
    console.log(row);
    const entry_id = row.original.id;
    Swal.fire({
      text: "Are you sure? You will not be able to recover this data!",
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: `No, cancel!`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteData({ id: entry_id });
      }
    });
  };

  return (
    <>
      <div className="nk-block-head nk-block-head-sm">
        <div className="nk-block-between">
          <div className="nk-block-head-content d-flex">
            <h3 className="nk-block-title page-title">BO</h3>
            {isLoading ? (
              <div className="spinner-border text-primary ms-2" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              ""
            )}
          </div>
          {privileges.includes("bo_create") && (<div className="nk-block-head-content">
            <NavLink
              to="/create-bo"
              className="toggle btn btn-icon btn-primary d-md-none"
              id="button-button-create-bo"
            >
              <em className="icon ni ni-plus"></em>
            </NavLink>

            <NavLink
              to="/create-bo"
              className="toggle btn btn-primary d-none d-md-inline-flex"
              id="button-button-create-bo"
            >
              <em className="icon ni ni-plus"></em>
              <span>Create BO</span>
            </NavLink>
          </div>)}
        </div>
      </div>

      <Table
        data={data ? data?.results.data : []}
        columns={columns}
        pagination
        pageIndex={boPageIndex}
        pageSize={boEntries}
        rowCount={data ? data.count : 0}
        globalSearch
        editRows={privileges.includes("bo_update") ? true : false}
        deleteRows={privileges.includes("bo_delete") ? true : false}
        filterModal={false}
        selectRows={false}
        onGlobalFilterChange={handleGlobalFilterChange}
        onRowEdit={handleEditRow}
        onRowDelete={handleDeleteRow}
        onPaginationChange={handlePagination}
      />
    </>
  );
};

export default BO;
